import { toast } from "react-toastify";
import "../../node_modules/react-toastify/dist/ReactToastify.css";

export function notify(message, autoClose, type, onClose) {
  if (sessionStorage.plugBlockNotify) return;

  toast(message, {
    type: type || "error",
    autoClose: autoClose === false ? false : true,
    onClose,
  });
}
